<template>
  <div>
    <v-row>
      <v-col cols="12">
        <router-link :to="{ name: 'newAnnouncement' }">
          <v-btn color="primary">{{ $t('announcements.new_announcement') }}</v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <data-table-with-pagination
          :headers="announcement_header"
          :dataList="announcement_list"
          :loading="load_table"
          :options="options"
          :itemLength="total_items"
        ></data-table-with-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getData } from '@/api'
import DataTableWithPagination from '@/components/DataTableWithPagination.vue'
import { globalFunc } from '@/global'
export default {
  name: 'announcements',
  components: {
    DataTableWithPagination,
  },
  mixins: [globalFunc],
  data: () => ({
    announcement_header: [],
    announcement_list: [],
    load_table: true,
    total_items: 0,
    current_page: 0,
    current_limit: 10,
    options: {},
  }),
  methods: {
    initializeHeader() {
      this.announcement_header = [
        {
          text: this.$t('announcements.select_year'),
          value: 'select_year',
          width: '100px',
        },
        {
          text: this.$t('announcements.publish_date'),
          value: 'publish_date',
          width: '115px',
        },
        {
          text: this.$t('announcements.document_title'),
          value: 'document_title',
        },
        {
          text: this.$t('announcements.upload_document'),
          value: 'upload_document',
          width: '150px',
        },
        { text: '', value: 'announcement_button', width: '200px' },
      ]
    },
    async initializeData() {
      try {
        this.load_table = true

        let params = new URLSearchParams()
        params.set('get_published_announcement', JSON.stringify({}))

        let announcement = await getData(params)

        let temp = []

        this.total_items = announcement.length

        for (let i = 0; i < announcement.length; i++) {
          let obj = announcement[i]
          temp.push({
            id: obj.id,
            select_year: obj.select_year,
            publish_date: obj.publish_date,
            document_title: obj.document_title.zh,
            upload_document: obj.document.zh,
          })
        }

        this.announcement_list = temp
        //globalFunc.log(this.announcement_list)
        this.load_table = false
      } catch (error) {
        globalFunc.log(error)
        this.load_table = false
      }
    },
  },
  created() {
    this.initializeHeader()
    this.initializeData()
  },
}
</script>
